// extracted by css-extract-rspack-plugin
export default {"Box":"suggestions-for-repository-module__Box__oGtX1Nr"};